import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentWebViewRoutingRoutingModule } from './payment-web-view-routing-routing.module';
import { PaymentWebViewComponent } from './payment-web-view.component';
// import { PaymentWebViewOptionsComponent } from './payment-web-view-options/payment-web-view-option.component';


@NgModule({
  declarations: [
    
  ],
  imports: [
    CommonModule,
    PaymentWebViewRoutingRoutingModule
  ]
})
export class PaymentWebViewRoutingModule { }
